module.exports = __webpack_public_path__ + "img/nl.1d8f6a80.svg";